/**
 * 可拖动分割条
 *
 * 三条分割线：
 *  #divider-lr  — 左右（改变 #left-panel 宽度）
 *  #divider-eo  — 编辑器 / 输出（改变 #output-panel 高度）
 *  #divider-fv  — 图形区 / 变量面板（改变 #var-panel 高度）
 */

function clamp(val, min, max) {
  return Math.min(Math.max(val, min), max);
}

/**
 * 水平分割条：拖动改变 panelA 的宽度，panelB 自动占满剩余。
 * container 用于计算总可用宽度。
 */
function initColResizer(divider, panelA, container, { min = 160 } = {}) {
  divider.addEventListener('mousedown', (e) => {
    e.preventDefault();
    const startX = e.clientX;
    const startW = panelA.offsetWidth;

    const onMove = (ev) => {
      const newW = clamp(
        startW + (ev.clientX - startX),
        min,
        container.offsetWidth - min,
      );
      panelA.style.width = newW + 'px';
    };

    const onUp = () => {
      document.removeEventListener('mousemove', onMove);
      document.removeEventListener('mouseup', onUp);
      document.body.style.cursor = '';
      document.body.style.userSelect = '';
    };

    document.body.style.cursor = 'col-resize';
    document.body.style.userSelect = 'none';
    document.addEventListener('mousemove', onMove);
    document.addEventListener('mouseup', onUp);
  });
}

/**
 * 垂直分割条：拖动改变下方 panelB 的高度，上方 panelA 自动占满剩余。
 * 向上拖动 → panelB 变高；向下拖动 → panelB 变小。
 */
function initRowResizer(divider, panelA, panelB, { min = 40, max = Infinity } = {}) {
  divider.addEventListener('mousedown', (e) => {
    e.preventDefault();
    const startY = e.clientY;
    const startH = panelB.offsetHeight;
    const container = panelA.parentElement;

    const onMove = (ev) => {
      const newH = clamp(
        startH - (ev.clientY - startY),
        min,
        Math.min(max, container.offsetHeight - min),
      );
      panelB.style.height = newH + 'px';
    };

    const onUp = () => {
      document.removeEventListener('mousemove', onMove);
      document.removeEventListener('mouseup', onUp);
      document.body.style.cursor = '';
      document.body.style.userSelect = '';
    };

    document.body.style.cursor = 'row-resize';
    document.body.style.userSelect = 'none';
    document.addEventListener('mousemove', onMove);
    document.addEventListener('mouseup', onUp);
  });
}

export function initResizers() {
  const workspace = document.getElementById('workspace');

  initColResizer(
    document.getElementById('divider-lr'),
    document.getElementById('left-panel'),
    workspace,
    { min: 180 },
  );

  initRowResizer(
    document.getElementById('divider-eo'),
    document.getElementById('editor-container'),
    document.getElementById('output-panel'),
    { min: 40, max: 600 },
  );

  initRowResizer(
    document.getElementById('divider-fv'),
    document.getElementById('figure-panel'),
    document.getElementById('var-panel'),
    { min: 40, max: 500 },
  );
}
